import { Component, OnInit, ElementRef, ViewChild } from '@angular/core'
import { Router } from '@angular/router'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { DateTextFieldValidator } from '../../../validations/date-text-field.validator'
import { DrugPlan } from '../../models/drug-plan'
import { PlanList } from '../../models/plan-list'
import { Notes } from '../../models/notes'
// import { ValidatedRadioButtonModel } from '../../../validations/validated-radio-button-group.component'
import { EnrollmentElectionType } from '../../models/enrollment-election-type'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { BeneficiaryInfo } from '../../models/enrollments'
import { Step2Model } from '../../models/Step2Model'
import { AddressDB } from '../../../user-management/models/address'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import { SubmitEnrollmentDataResponse } from '../../models/submit-enrollment-data-response'
import { FormValidationService } from '../../../validations/form-validation-service'
import { ValidatedSelectOptionModel as State } from '../../../validations/validated-dropdown.component'
import { LicenseApptGateway } from '../../../user-management/gateways/license-appt-gateway'
import { License } from '../../../user-management/models/license-details'
import { StateGateway } from '../../../common/gateways/state-gateway'
import { UserAccessGateway } from '../../../common/gateways/user-access-gateway'
import { PaymentAccount } from '../../models/payment-account'
import { PortalGlobals } from '../../../portalglobals'
import { PaymentOption, PaymentOptions } from '../../models/payment-options'
import { isMMDDYYYY } from '../../../../app/validations/is-mmddyyyy'
import * as moment from 'moment'
import { GetEnrollmentDataResponse, GetEnrollmentDataByID } from '../../models/get-enrollment-data-response'
import { EnrollmentCacheData } from '../../models/EnrollmentCacheData'
import { PrescriptionDrug } from '../common/prescription-drug-component'
import * as _ from 'lodash'
import { ValidatedRadioButtonModel } from '../../../validations/validated-radio-button-group.component'
import { RaceEthnicityComponent } from '../common/race-ethnicity.component'
import { AccessibilityComponent } from '../common/accessibility.component'

@Component({
    selector: 'DataEntryStep2',
    templateUrl: 'data-entry-step2.html'
})
export class DataEntryStep2Component implements OnInit {
    private _raceEthnicityComponent: RaceEthnicityComponent
    enrollmentCacheData: EnrollmentCacheData = {} as EnrollmentCacheData
    getEnrollmentDataResponse: GetEnrollmentDataResponse = new GetEnrollmentDataResponse()
    notBlankValidator = new NotBlankGenericFieldValidator()
    validatedDate = new DateTextFieldValidator()
    drugPlanModel = {} as DrugPlan
    notesModel = {} as Notes
    isValidAgent: boolean
    electionperiod: string
    planList = [] as PlanList[]
    // enrollmentElectionTypes: EnrollmentElectionType[] = [new EnrollmentElectionType()]
    orgID = '9'
    selectedElectionPeriod: string
    paymentMethod: typeof PaymentOptions
    step2Model: Step2Model
    reasonCode = ''
    periodSelected = ''
    dateField: boolean
    residentialAddress: AddressDB = {} as AddressDB
    mailingAddress: AddressDB = {} as AddressDB
    enrollmentViewModel: EnrollmentViewModel = new EnrollmentViewModel()
    ErrorMessages: any[]
    hasError: boolean
    hasIncompleteError: boolean
    states: State[] = [] as State[]
    allStates: State[] = [] as State[]
    userProfileID: number = 0
    disabled: boolean = false
    mailingAddressValid: boolean = false
    mailingCityValid: boolean = false
    mailingStateValid: boolean = false
    public loading: boolean = false
    isExternalAgentEnrl:boolean = false
    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef
    PaperlessOption: boolean
    public rdBtnEOB: ValidatedRadioButtonModel[] = []
    emailLabel: string
    eobOptionLabel: string
    benefitaryModel: BeneficiaryInfo = {} as BeneficiaryInfo
    // enrollment: EnrollmentFormViewModel = {} as EnrollmentFormViewModel
    paymentOption: string = ''
    accessibilityValue: string
    isEOB: boolean
    isPOBox: boolean
    visibleFrom2026: boolean
    accessibilityComponent: AccessibilityComponent
    paymentAccount: PaymentAccount = {} as PaymentAccount
    @ViewChild('prescripitionDrug', { static: true }) prescripitionDrug: PrescriptionDrug
    @ViewChild('accessibility') accessibility: AccessibilityComponent

    constructor(
        private router: Router,
        private _enrollementGateway: EnrollmentGateway,
        protected formValidationService: FormValidationService,
        private _userAccessGateway: UserAccessGateway,
        private _licenseAppGateway: LicenseApptGateway,
        private _stateGateway: StateGateway,
        public _global: PortalGlobals
    ) {
        this._raceEthnicityComponent = new RaceEthnicityComponent(this._enrollementGateway)
        this.step2Model = {} as Step2Model
        this.step2Model.notes = {} as Notes
        this.step2Model.prescriptionDrug = {} as DrugPlan
        this.step2Model.beneficiaryInfo = {} as BeneficiaryInfo
        this.paymentMethod = {} as typeof PaymentOptions
        this.ErrorMessages = [] as any[]
        if (this._global.selectedPlanYear > this._global.Planyear2025) {
            this.visibleFrom2026 = true;
        }
    }

    ngOnInit() {
        
      
        if (this.enrollmentViewModel.APPDT) {
            localStorage.setItem('APPDATE1', this.enrollmentViewModel?.APPDT?.toString() ?? '');
            this.enrollmentViewModel.APPDT = null;
        }
      

        this.hasError = false
        var User = localStorage.getItem('UserSessionContext')
        this._global.currentUser = JSON.parse(User!)

        this.enrollmentViewModel = this._enrollementGateway.getEnrollmentViewModel()
        this.enrollmentViewModel.ISBACK = false
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        if (this.enrollmentViewModel === null || this.enrollmentViewModel === undefined) {
            this.router.navigate(['/' + insCo + '/enrollment/data-entry/Step1'])
        }
        
        if (
            this.enrollmentViewModel.POVERIND !== undefined &&
            this.enrollmentViewModel.POVERIND != null &&
            this.enrollmentViewModel.POVERIND != '' &&
            this.enrollmentViewModel.POVERIND === '1') {
            this.poBoxChecked(true)
        }
        else {
            this.poBoxChecked(false)
        }

        //Get the Paperless settings from config
        this._enrollementGateway.getPaperlessSetting('SSIDataEntryPaperlessSetting').subscribe((data) => {
            this.PaperlessOption = data
            this.enrollmentViewModel.PaperlessSettings = data

            if (this.PaperlessOption) {
                this.emailLabel = 'Email Address (Required for Paperless)'
                //this.rdBtnEOB.push({ value: '3', htmlLabel: 'Yes, I want to go paperless for all available and future documents' }, { value: 'N', htmlLabel: 'No, I want to receive all my documents in the mail' })
                this.eobOptionLabel = 'Yes, I want to receive my EOB statements electronically.'

                if (
                    this.enrollmentViewModel.EOB !== undefined &&
                    this.enrollmentViewModel.EOB != null &&
                    this.enrollmentViewModel.EOB != '' &&
                    (this.enrollmentViewModel.EOB.toLowerCase() === 'eeob' ||
                        this.enrollmentViewModel.EOB.toLowerCase() === '5' ||
                        this.enrollmentViewModel.EOB.toLowerCase() === '6' ||
                        this.enrollmentViewModel.EOB.toLowerCase() === '7' ||
                        this.enrollmentViewModel.EOB.toLowerCase() === '9')
                ) {
                    this.eobOptionChecked(true)
                    this.isEOB = true
                } else {
                    this.eobOptionChecked(false)
                    this.isEOB = false
                }
            } else {
                this.emailLabel = 'Email Address (optional)'
                this.rdBtnEOB.push(
                    { value: 'EEOB', htmlLabel: 'Yes, I want to receive my EOB statements electronically' },
                    { value: 'PEOB', htmlLabel: 'No, I want to receive my EOB statements in the mail' }
                )
            }
        })

        if (this.enrollmentViewModel.AGENTID === null || this.enrollmentViewModel.AGENTID === undefined || this.enrollmentViewModel.AGENTID === '') {
            if (sessionStorage.getItem('EnrollmentCache') != null) {
                this.enrollmentCacheData = JSON.parse(sessionStorage.getItem('EnrollmentCache')!)

                //this.getEnrollmentDataResponse = this._enrollementGateway.getEnrollmentDataByKey(this.EnrollmentKey)

                this.loading = true
                this._enrollementGateway.getEnrollmentDataByKey(this.enrollmentCacheData.EnrollmentKey).subscribe(
                    (getEnrollmentDataResponse: GetEnrollmentDataResponse) => {
                        this.enrollmentViewModel = this._enrollementGateway.getEnrollmentViewModelByKey(getEnrollmentDataResponse)
                        this.enrollmentViewModel.ENROLLKEY = this.enrollmentCacheData.EnrollmentKey
                        this.enrollmentViewModel.ADMINID = this.enrollmentCacheData.AdminID
                        this.enrollmentViewModel.AGENTORGID = this.enrollmentCacheData.AgentOrgID
                        this.enrollmentViewModel.AGENTNAME = this.enrollmentCacheData.AgentName
                        this.enrollmentViewModel.PLANTYPENAME = this.enrollmentCacheData.PLANTYPENAME
                        this.enrollmentViewModel.USERNAME = this.enrollmentCacheData.USERNAME
                        this.enrollmentViewModel.FORMNAME = this.enrollmentCacheData.FORMNAME
                        this.enrollmentViewModel.SEPREASONTEXT = this.enrollmentCacheData.SEPREASONTEXT
                        this._global.selectedPlanYear = this.enrollmentCacheData.PlanYear

                        this.paymentOption = this.enrollmentViewModel.PWO
                        this.prescripitionDrug.toggle(this.enrollmentViewModel.OTHCVRG, 'OTHCVRG')
                        this.enrollmentViewModel.PaperlessSettings = this.enrollmentCacheData.PaperlessSettings

                        this.LoadData()
                        this.loading = false
                    },
                    (err) => {
                        this.loading = false
                    }
                )
            } else {
                this.router.navigate(['/' + insCo + '/enrollment/data-entry/Step1'])
            }
        } else {
            this.LoadData()
        }
    }
   
    eobOptionChecked(option: boolean) {
        if (option) {
            this.emailLabel = 'Email Address (Required for Paperless)'
            this.enrollmentViewModel.EOB = 'EEOB'
            this.isEOB = true
        } else {
            this.emailLabel = 'Email Address (Optional)'
            this.enrollmentViewModel.EOB = 'PEOB'
            this.isEOB = false
        }
    }
    poBoxChecked(option: boolean) {
        if (option)
        {
            this.enrollmentViewModel.POVERIND = '1'
            this.isPOBox = true
        }
        else
        {
            this.enrollmentViewModel.POVERIND = '0'
            this.isPOBox = false
        }
       
    }
    eobOptionChanged(option: string) {
        if (!this.PaperlessOption) {
            if (option === 'EEOB') {
                this.emailLabel = 'Email Address'
            } else {
                this.emailLabel = 'Email Address (optional)'
            }
        } else {
            if (option === 'EEOB') {
                this.emailLabel = 'Email Address (Required for Paperless)'
            } else {
                this.emailLabel = 'Email Address (Optional)'
            }
        }
        this.enrollmentViewModel.EOB = option
    }

    LoadData(): void {
        this.accessibilityValue = this.enrollmentViewModel.accessibility;

        if (this.enrollmentViewModel.residentialAddress !== undefined) this.residentialAddress = this.enrollmentViewModel.residentialAddress
        if (this.enrollmentViewModel.mailingAddress !== undefined) this.mailingAddress = this.enrollmentViewModel.mailingAddress
        //if (this.enrollmentViewModel.beneficiaryInfo !== undefined)
        //    this.benefitaryModel = this.enrollmentViewModel.beneficiaryInfo
        this._stateGateway.getAllStates().subscribe((states: State[]) => {
            this.allStates = states
            if (
                this.enrollmentViewModel.AGENTDETAILS !== undefined &&
                (this.enrollmentViewModel.AGENTDETAILS.IsDataEntrySpecialist || this.enrollmentViewModel.AGENTDETAILS.IsDataEntryGroupSpecialist)
            ) {
                this.states = this.allStates
                this.states.unshift({ value: 0, text: '-- Choose One --' })
                _.remove(this.states, function (stat) {
                    return stat.value === 'VI' || stat.value === 'PR'
                })
            } else {
                this._licenseAppGateway.getUserLicenseDetailsForEnrollment(this.enrollmentViewModel.AGENTNAME).subscribe((state) => {
                    if (state.length > 0) {
                        for (let i = 0; i < state.length; i++) {
                            this.states.push({ value: state[i].value, text: state[i].text })
                        }
                    } else {
                        //For agreement 40 agent get all states if no license assigned to agent
                        if (
                            this.enrollmentViewModel.AGENTDETAILS !== undefined &&
                            this.enrollmentViewModel.AGENTDETAILS.IsAgent &&
                            this.enrollmentViewModel.AGENTDETAILS.AgreementVersionNumber.trim() === '40'
                        ) {
                            this.states = this.allStates
                        }
                    }
                    this.states.unshift({ value: 0, text: '-- Choose One --' })
                })
            }

            if (this.enrollmentViewModel.APPST === undefined || this.enrollmentViewModel.APPST === '' || this.enrollmentViewModel.APPST === '0') {
                this.residentialAddress.state = '0'
            }
            if (this.enrollmentViewModel.MAILST === undefined || this.enrollmentViewModel.MAILST === '' || this.enrollmentViewModel.MAILST === '0') {
                this.mailingAddress.state = '0'
            }
        })
    }

    periodSelectdChanged(period: string) {
        this.periodSelected = this.enrollmentViewModel.ELECTION = period
        let currDate = new Date()
        if (this.periodSelected === 'OpenEnrollment') {
            if (this.enrollmentViewModel.EFFDT != new Date(currDate.getFullYear() + 1, 0, 1)) {
                if (currDate.getMonth() > 3) this.enrollmentViewModel.EFFDT = new Date(currDate.getFullYear() + 1, 0, 1)
                else this.enrollmentViewModel.EFFDT = new Date(currDate.getFullYear(), 0, 1)
            }
        } else {
            if (this.enrollmentViewModel.ENROLLKEY === undefined || this.enrollmentViewModel.ENROLLKEY === '') {
                if (currDate.getMonth() == 11) {
                    this.enrollmentViewModel.EFFDT = new Date(currDate.getFullYear() + 1, 0, 1)
                } else {
                    this.enrollmentViewModel.EFFDT = new Date(currDate.getFullYear(), currDate.getMonth() + 1, 1)
                }

                //If Year of Effective Date is not same as that of selected plan Year, default effective date will be 01/01 of next year
                if (this._global.selectedPlanYear !== undefined && this._global.selectedPlanYear !== 0) {
                    if (this.enrollmentViewModel.EFFDT.getFullYear() !== this._global.selectedPlanYear) {
                        if (this._global.selectedPlanYear > currDate.getFullYear())
                            this.enrollmentViewModel.EFFDT = new Date(currDate.getFullYear() + 1, 0, 1)
                    }
                }
            }
        }
    }
    reasonCodeChanged(SelReasonCode: any) {
        //   this.enrollmentViewModel.SEPREASONTEXT = SelReasonCode.text
        //   this.reasonCode = this.enrollmentViewModel.SEPREASONCD = SelReasonCode.value
        this.enrollmentViewModel.SEPREASONTEXT = SelReasonCode.text
        this.enrollmentViewModel.ELECTIONTYPEID = SelReasonCode.id
        this.enrollmentViewModel.SEPREASONCD = SelReasonCode.value
        this.reasonCode = this.enrollmentViewModel.ELECTIONTYPEID + '|' + this.enrollmentViewModel.SEPREASONCD
        this.reasonCode = SelReasonCode.id + '|' + SelReasonCode.value
    }
    hasDateField(datefield: boolean) {
        this.dateField = datefield
    }
    change(enrollment: BeneficiaryInfo) {
        this.enrollmentViewModel.beneficiaryInfo = enrollment
        this.enrollmentViewModel.HICN = enrollment.medicareId
        this.enrollmentViewModel.APPFN = enrollment.firstName
        this.enrollmentViewModel.APPLN = enrollment.lastName
        this.enrollmentViewModel.APPDOB = enrollment.dateOfBirth
        this.enrollmentViewModel.CELLPHONE = enrollment.cellPhone || ''
        // this.enrollmentViewModel.APPEMAIL = enrollment.email
        this.enrollmentViewModel.APPGEN = enrollment.gender
        this.enrollmentViewModel.APPMI = enrollment.middleInitial || ''
        this.enrollmentViewModel.MEDA = enrollment.medicarePartAEffectiveDate
        this.enrollmentViewModel.MEDB = enrollment.medicarePartBEffectiveDate
        //  this.enrollmentViewModel.StrMEDA = enrollment.strmedicarePartAEffectiveDate
        // this.enrollmentViewModel.StrMEDB = enrollment.strmedicarePartBEffectiveDate
        this.enrollmentViewModel.SUFFIX = enrollment.suffixName || ''
        this.enrollmentViewModel.APPMI = enrollment.middleInitial || ''
        this.enrollmentViewModel.TITLE = enrollment.title
        this.enrollmentViewModel.APPPHONE = enrollment.primaryPhone || ''
    }

    // Payment Options
    paymentOptionChanged(option: string) {
        this.paymentOption = this.enrollmentViewModel.PWO = option
    }

    paymentAccountChanged(paymentAccount: PaymentAccount) {
        this.paymentAccount = this.enrollmentViewModel.paymentAccount = paymentAccount
        this.enrollmentViewModel.ACCHOLDERNAME = paymentAccount.holderName
        this.enrollmentViewModel.ROUTINGNB = paymentAccount.routingNumber
        this.enrollmentViewModel.ACCOUNTNB = paymentAccount.number
        this.enrollmentViewModel.FININSTNAME = paymentAccount.institution
        this.enrollmentViewModel.EFTTYPE = paymentAccount.type || ''
    }

    onSubmit(): void {
        this.isValidAgent = true
    }

    formSubmit(): void {
        
        this.ErrorMessages = [] as any[]

        // SUBMISSIONTYPECODE='PROSPECT' Only for Step 1 & 2 & 3 for enrollment
        this.enrollmentViewModel.SUBMISSIONTYPECODE = 'PROSPECT'
        this.enrollmentViewModel.STEPCODE = '2'
        this.enrollmentViewModel.PLANYEAR = String(this._global.selectedPlanYear)

        //Dummy Data --start
        /*this.isValidAgent = true
        this.enrollmentViewModel.COMPLETEIND = false
        this.enrollmentViewModel.AGENTFN = 'Venu'
        this.enrollmentViewModel.AGENTLN = 'Panda'
        this.enrollmentViewModel.AGENTID = '45404'
        this.enrollmentViewModel.HICN = '123456789a'
        this.enrollmentViewModel.CONF = 'Venu'
        this.enrollmentViewModel.APPFN = 'testF'
        this.enrollmentViewModel.APPMI = ''
        this.enrollmentViewModel.APPLN = 'testL'
        //  this.enrollmentViewModel.EXTERNALID = false

        this.enrollmentViewModel.APPADD1 = 'addr1'
        this.enrollmentViewModel.APPADD2 = ''
        this.enrollmentViewModel.APPCITY = 'test'
        this.enrollmentViewModel.APPST = 'AZ'
        this.enrollmentViewModel.APPZIP = '85001'
        this.enrollmentViewModel.MAILADD1 = 'mailaddr1'
        this.enrollmentViewModel.MAILADD2 = 'mailaddr2'
        this.enrollmentViewModel.MAILCITY = 'mailcity'
        this.enrollmentViewModel.MAILST = 'AZ'
        this.enrollmentViewModel.MAILZIP = '85001'
        // this.enrollmentViewModel.EMERPHONE = ''
        //  this.enrollmentViewModel.EMERREL = ''
        // this.enrollmentViewModel.EMERNAME = ''
        // this.enrollmentViewModel.EMERREL = ''
        this.enrollmentViewModel.LTCFACILITY = ''
        this.enrollmentViewModel.LTCPHONE = ''
        // this.enrollmentViewModel.CC = ''
        this.enrollmentViewModel.SUFFIX = ''
        // this.enrollmentViewModel.ADMINID = '156716'
        this.enrollmentViewModel.ELECTION = 'FirstTime'
        // this.enrollmentViewModel.UNMTHS = ''
        this.enrollmentViewModel.APPDT = new Date(2018, 1, 1)
        this.enrollmentViewModel.AUTHREPNAME = ''
        this.enrollmentViewModel.AUTHREPPHONE = ''
        // this.enrollmentViewModel.AUTHREPEMAIL = ''
        this.enrollmentViewModel.AUTHREPREL = ''
        this.enrollmentViewModel.AUTHREPADD1 = ''
        this.enrollmentViewModel.AUTHREPADD2 = ''
        this.enrollmentViewModel.AUTHREPCITY = ''
        this.enrollmentViewModel.AUTHREPST = ''
        this.enrollmentViewModel.AUTHREPZIP = ''
        //  this.enrollmentViewModel.AUTHREPCOPYIND = ''
        this.enrollmentViewModel.ATESTPROOF = 'abhinav.bahuguna@cvshealth.com'
        this.enrollmentViewModel.CUID = '9110'
        this.enrollmentViewModel.APPDOB = new Date(1988, 21, 1)
        this.enrollmentViewModel.APPGEN = 'male'
        this.enrollmentViewModel.PLANST = 'AZ'
        this.enrollmentViewModel.PLANTYPE = 'SSIChoice'
        this.enrollmentViewModel.PLANYEAR = '2018'
        this.enrollmentViewModel.LANG = 'english'
        this.enrollmentViewModel.PWO = 'Deduction from Social Security Check'
        this.enrollmentViewModel.OTHCVRG = 'no'
        this.enrollmentViewModel.OTHCVRGNAME = ''
        this.enrollmentViewModel.OTHCVRGGRP = ''
        this.enrollmentViewModel.OTHCVRGID = ''
        this.enrollmentViewModel.COBBIN = ''
        this.enrollmentViewModel.COBPCN = ''
        // this.enrollmentViewModel.COBEFFDT = new Date(2017, 3, 1)
        // this.enrollmentViewModel.COBTERMDT = new Date(2017, 3, 1)
        //  this.enrollmentViewModel.SECCARRIER = ''
        // this.enrollmentViewModel.SECACCOUNT = ''
        // this.enrollmentViewModel.SECGROUP = ''
        // this.enrollmentViewModel.SECMBRID = ''
        // this.enrollmentViewModel.RELCD = ''
        // this.enrollmentViewModel.PERSONCD = ''
        //  this.enrollmentViewModel.FAMILYID = ''
        // this.enrollmentViewModel.CAREFAC = ''
        this.enrollmentViewModel.DEX = 'MLPAP'
        this.enrollmentViewModel.AUTHREPIND = 'No'
        this.enrollmentViewModel.TITLE = ''
        this.enrollmentViewModel.EFFDT = new Date(2018, 4, 1)
        this.enrollmentViewModel.SEPREASONCD = 125
        this.enrollmentViewModel.SEPEFFDT = new Date()
        this.enrollmentViewModel.NOTES = 'test notes1'
        this.enrollmentViewModel.APPPHONE = '1234567890'
        this.enrollmentViewModel.MEDA = new Date()
        this.enrollmentViewModel.MEDB = new Date()
        this.enrollmentViewModel.PLANNAME = 'SilverScript Choice'
        //this.enrollmentViewModel.AGENTDEX = 'MLPAP'
        this.enrollmentViewModel.ACCOUNTNB = ''
        this.enrollmentViewModel.FININSTNAME = ''
        this.enrollmentViewModel.ROUTINGNB = ''
        this.enrollmentViewModel.ACCHOLDERNAME = ''
        this.enrollmentViewModel.EFTTYPE = ''
        // this.enrollmentViewModel.NOTES2 = ''
        this.enrollmentViewModel.APPSIGNEDIND = true
        // this.enrollmentViewModel.SESSIONID = ''
        this.enrollmentViewModel.AUTHREPSIGNEDIND = false
        // this.enrollmentViewModel.POVERIND = ''
        // this.enrollmentViewModel.SOA = 'ScopeIncluded'*/
        //Dummy Data --end
        if (this.enrollmentViewModel.PWO !== 'Automatic Bank Draft Withdrawal') {
            this.resetBankDeatils()
        }
        if (this.enrollmentViewModel.COBEFFDT === undefined) {
            this.enrollmentViewModel.COBEFFDT = undefined
        }
        if (this.enrollmentViewModel.COBTERMDT === undefined) {
            this.enrollmentViewModel.COBTERMDT = undefined
        }
        
        if (this.enrollmentViewModel.OTHCVRG !== null && this.enrollmentViewModel.OTHCVRG !== undefined) {
            if (this.enrollmentViewModel.OTHCVRG.toUpperCase() === 'NO') {
                this.enrollmentViewModel.COBBIN = ''
                this.enrollmentViewModel.COBPCN = ''
                this.enrollmentViewModel.OTHCVRGNAME = ''
                this.enrollmentViewModel.OTHCVRGID = ''
                this.enrollmentViewModel.OTHCVRGGRP = ''
                this.enrollmentViewModel.COBTERMDT = undefined
                this.enrollmentViewModel.COBEFFDT = undefined
            }
        }

        this.enrollmentViewModel.Race = this._raceEthnicityComponent.submitRaceDynamic(this.enrollmentViewModel.Race)
        this.enrollmentViewModel.Ethnicity = this._raceEthnicityComponent.submitEthnicityDynamic(this.enrollmentViewModel.Ethnicity)
        this.enrollmentViewModel.EOB = this.SetLanFormat(this.enrollmentViewModel.EOB, this.enrollmentViewModel.accessibility)

        this.enrollmentViewModel.displayEthnicity = this._raceEthnicityComponent.selectedEthnicityDynamicModel(
            this.enrollmentViewModel.selectedEthnicity
        )
        this.enrollmentViewModel.displayRace = this._raceEthnicityComponent.selectedRaceDynamicModel(this.enrollmentViewModel.selecteRace)

        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
        if (!this.isFormInvalid()) {
            this.loading = true
            let mailStateCode = this.enrollmentViewModel.MAILST
            let mailZip = this.enrollmentViewModel.MAILZIP
            if (this.enrollmentViewModel.SAMEADDRESS) {
                mailStateCode = '0'
                mailZip = '0'
            }
            this._enrollementGateway.validateZip(this.enrollmentViewModel.APPST, this.enrollmentViewModel.APPZIP, mailStateCode, mailZip).subscribe(
                (model: string[]) => {
                    if (model !== undefined && model !== null && model.length !== 0) {
                        this.ErrorMessages = model
                        this.hasError = true
                        this.focusableEleTop.nativeElement.focus()
                        this.loading = false
                    } else {
                        this._enrollementGateway.CheckDuplicateEnrollment(this.enrollmentViewModel).subscribe(
                            (model: string[]) => {
                                if (model !== undefined && model !== null && model.length !== 0) {
                                    this.ErrorMessages = model
                                    this.hasError = true
                                    this.focusableEleTop.nativeElement.focus()
                                    this.loading = false
                                } else {
                                    if (this.enrollmentViewModel.ENROLLKEY !== undefined && this.enrollmentViewModel.ENROLLKEY !== '') {
                                        console.log('EnrollmentKey: ' + this.enrollmentViewModel.ENROLLKEY)

                                        this._enrollementGateway.UpdateEnrollmentData(this.enrollmentViewModel).subscribe(
                                            (model: SubmitEnrollmentDataResponse) => {
                                                let response = model
                                                if (response !== undefined) {
                                                    if (this.enrollmentViewModel.FORMNAME === 'DATAENTRY') {
                                                        for (let i = 0; i < response.Errors.length; i++) {
                                                           if (
                                                                response.Errors[i].FieldCode === 'APPDT' ||
                                                               response.Errors[i].FieldCode === '4028' ||
                                                                response.Errors[i].FieldCode === '4029'
                                                          ) {
                                                                response.Errors.splice(i, 1)
                                                               i--
                                                            }
                                                       }
                                                    }

                                                    if (response.Errors !== undefined && response.Errors.length > 0) {
                                                        this.hasError = true

                                                        for (let i = 0; i < response.Errors.length; i++) {
                                                            this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                                                        }
                                                        this.focusableEleTop.nativeElement.focus()
                                                    } else {
                                                        //this.enrollment.ENROLLKEY = response.EnrollmentKey
                                                        //this.enrollment.CONF = response.confirmationNumber
                                                        this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
                                                        this.loading = false
                                                        this.router.navigate(['/' + insCo + '/enrollment/data-entry/Step3'])
                                                    }
                                                } else {
                                                    this.ErrorMessages.push('Error while submitting data, please try again.')
                                                    this.hasError = true
                                                    this.focusableEleTop.nativeElement.focus()
                                                }
                                                this.loading = false
                                            },
                                            (err) => {
                                                this.loading = false
                                            }
                                        )
                                    } else {
                                        this._enrollementGateway.SubmitEnrollmentData(this.enrollmentViewModel).subscribe(
                                            (model: SubmitEnrollmentDataResponse) => {
                                                let response = model
                                                if (response !== undefined) {
                                                    for (let i = 0; i < response.Errors.length; i++) {
                                                       if (
                                                           response.Errors[i].FieldCode === 'APPDT' ||
                                                           response.Errors[i].FieldCode === '4028' ||
                                                           response.Errors[i].FieldCode === '4029'
                                                       ) {
                                                           response.Errors.splice(i, 1)
                                                          i--
                                                       }
                                                    }

                                                    if (response.Errors !== undefined && response.Errors.length > 0) {
                                                        this.hasError = true

                                                        for (let i = 0; i < response.Errors.length; i++) {
                                                            this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                                                        }
                                                        this.hasError = true
                                                        this.focusableEleTop.nativeElement.focus()
                                                    } else {
                                                        if (
                                                            response.EnrollmentKey !== undefined &&
                                                            response.EnrollmentKey !== '' &&
                                                            response.EnrollmentKey !== null
                                                        ) {
                                                            this.enrollmentViewModel.ENROLLKEY = response.EnrollmentKey
                                                            this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
                                                            this.loading = false

                                                            this.enrollmentCacheData.EnrollmentKey = response.EnrollmentKey
                                                            this.enrollmentCacheData.AgentName = this.enrollmentViewModel.AGENTNAME
                                                            this.enrollmentCacheData.AgentID = this.enrollmentViewModel.AGENTID
                                                            this.enrollmentCacheData.AdminID = this.enrollmentViewModel.ADMINID
                                                            this.enrollmentCacheData.AgentOrgID = this.enrollmentViewModel.AGENTORGID
                                                            this.enrollmentCacheData.PLANTYPENAME = this.enrollmentViewModel.PLANTYPENAME
                                                            this.enrollmentCacheData.USERNAME = this.enrollmentViewModel.USERNAME
                                                            this.enrollmentCacheData.FORMNAME = this.enrollmentViewModel.FORMNAME
                                                            this.enrollmentCacheData.PlanYear = this._global.selectedPlanYear
                                                            this.enrollmentCacheData.SEPREASONTEXT = this.enrollmentViewModel.SEPREASONTEXT
                                                            this.enrollmentCacheData.PaperlessSettings = this.enrollmentViewModel.PaperlessSettings

                                                            sessionStorage.setItem('EnrollmentCache', JSON.stringify(this.enrollmentCacheData))

                                                            this.router.navigate(['/' + insCo + '/enrollment/data-entry/Step3'])
                                                        } else {
                                                            this.ErrorMessages.push('Error while submitting data, please try again.')
                                                            this.hasError = true
                                                            this.focusableEleTop.nativeElement.focus()
                                                        }
                                                    }
                                                } else {
                                                    this.ErrorMessages.push('Error while submitting data, please try again.')
                                                    this.hasError = true
                                                    this.focusableEleTop.nativeElement.focus()
                                                }
                                                this.loading = false
                                            },
                                            (err) => {
                                                this.loading = false
                                            }
                                        )
                                    }
                                }
                            },
                            (err) => {
                                this.loading = false
                            }
                        )
                    }
                },
                (err) => {
                    this.loading = false
                }
            )
        } else {
            this.focusableEleTop.nativeElement.focus()
        }
    }
    resetBankDeatils() {
        this.enrollmentViewModel.ACCHOLDERNAME = ''
        this.enrollmentViewModel.EFTTYPE = ''
        this.enrollmentViewModel.FININSTNAME = ''
        this.enrollmentViewModel.ROUTINGNB = ''
        this.enrollmentViewModel.ACCOUNTNB = ''

        this.paymentAccount.holderName = ''
        this.paymentAccount.institution = ''
        this.paymentAccount.number = ''
        this.paymentAccount.routingNumber = ''
        this.paymentAccount.type = null
        this.paymentAccount = {} as PaymentAccount
        this.enrollmentViewModel.paymentAccount = this.paymentAccount
    }
    isFormInvalid(): boolean {
        this.hasError = false
        //let HICNregex = new RegExp('[1-9](?![SLOIBZ])[A-Z](?![SLOIBZ])[A-Z 0-9][0-9](?![SLOIBZ])[A-Z](?![SLOIBZ])[A-Z 0-9][0-9](?![SLOIBZ])[A-Z](?![SLOIBZ])[A-Z][0-9][0-9]')

        //let validHICN = HICNregex.test(this.enrollmentViewModel.HICN)
        //if (!validHICN) {
        //    this.ErrorMessages.push('Invalid Medicare Number Format')
        //    this.hasError = true
        //}
        if (this.enrollmentViewModel.ELECTION !== undefined) {
            if (this.enrollmentViewModel.SEPREASONTEXT === undefined || this.enrollmentViewModel.SEPREASONTEXT === '') {
                this.ErrorMessages.push('Enrollment Criteria is required')
                this.hasError = true
            }
            if (this.enrollmentViewModel.ELECTION === 'Special') {
                if (this.dateField === true) {
                    if (this.enrollmentViewModel.SEPEFFDT === undefined || this.enrollmentViewModel.SEPEFFDT === null) {
                        this.ErrorMessages.push('SEP date is required')
                        this.hasError = true
                    }
                }
            }
        }

        if (this.enrollmentViewModel.ELECTION === undefined || this.enrollmentViewModel.ELECTION === '') {
            this.ErrorMessages.push('Election Status is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.APPADD1 === undefined || this.enrollmentViewModel.APPADD1 === '') {
            this.ErrorMessages.push('Street Address is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.APPCITY === undefined || this.enrollmentViewModel.APPCITY === '') {
            this.ErrorMessages.push('City is required')
            this.hasError = true
        } else {
            let regexCityVal = /^[A-Za-z\s\-.]+$/

            let isCityValid = regexCityVal.test(this.enrollmentViewModel.APPCITY)
            if (!isCityValid) {
                this.hasError = true
                this.ErrorMessages.push('Please enter valid City')
            }
        }

        if (this.enrollmentViewModel.APPST === undefined || this.enrollmentViewModel.APPST === '' || this.enrollmentViewModel.APPST === '0') {
            this.ErrorMessages.push('State is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.APPZIP === undefined || this.enrollmentViewModel.APPZIP === '') {
            this.ErrorMessages.push('Zip is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.MAILADD1 === undefined || this.enrollmentViewModel.MAILADD1 === '') {
            this.ErrorMessages.push('Mailing Address is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.MAILCITY === undefined || this.enrollmentViewModel.MAILCITY === '') {
            this.ErrorMessages.push('Mailing City is required')
            this.hasError = true
        } else {
            let regexCityVal = /^[A-Za-z\s\-.]+$/

            let isCityValid = regexCityVal.test(this.enrollmentViewModel.MAILCITY)
            if (!isCityValid) {
                this.hasError = true
                this.ErrorMessages.push('Please enter valid Mailing City')
            }
        }
        if (this.enrollmentViewModel.MAILST === undefined || this.enrollmentViewModel.MAILST === '' || this.enrollmentViewModel.MAILST === '0') {
            this.ErrorMessages.push('Mailing State is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.MAILZIP === undefined || this.enrollmentViewModel.MAILZIP === '') {
            this.ErrorMessages.push('Mailing Zip is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.APPLN === undefined || this.enrollmentViewModel.APPLN === '') {
            this.ErrorMessages.push('Last Name is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.APPFN === undefined || this.enrollmentViewModel.APPFN === '') {
            this.ErrorMessages.push('First Name is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.APPDOB === undefined || this.enrollmentViewModel.APPDOB === null) {
            this.ErrorMessages.push('Date of Birth is required')
            this.hasError = true
        } else {
            let dob = moment(this.enrollmentViewModel.APPDOB, 'MM/DD/YYYY')

            if (dob.isSameOrBefore('12/31/1889')) {
                this.hasError = true
                this.ErrorMessages.push('Invalid Date of Birth.')
            } else {
                if (!isMMDDYYYY(this.enrollmentViewModel.APPDOB.toString())) {
                    this.ErrorMessages.push('Date of Birth does not contain a valid Date')
                    this.hasError = true
                }
            }
        }

        if (this.enrollmentViewModel.APPGEN === undefined || this.enrollmentViewModel.APPGEN === '') {
            this.ErrorMessages.push('Sex is required')
            this.hasError = true
        }
        //if (this.enrollmentViewModel.APPDT === undefined || this.enrollmentViewModel.APPDT === null) {
        //    this.ErrorMessages.push('Application Date is required')
        //    this.hasError = true

        //}
        //if (this.enrollmentViewModel.PLANST === undefined || this.enrollmentViewModel.PLANST === null) {
        //    this.ErrorMessages.push('Plan State is required')
        //    this.hasError = true

        //}

        if (this.enrollmentViewModel.HICN === undefined || this.enrollmentViewModel.HICN === null) {
            this.ErrorMessages.push('Medicare Number is required')
            this.hasError = true
        } else if (this.enrollmentViewModel.HICN.indexOf('-') > -1) {
            this.ErrorMessages.push('Please enter Medicare Number without -')
            this.hasError = true
        }

        /*
        if (this.enrollmentViewModel.CURRENTGENDER == "4" && (this.enrollmentViewModel.CURRENTGENDEROTH == undefined
            || this.enrollmentViewModel.CURRENTGENDEROTH == '')) {
            this.ErrorMessages.push('Different Gender Identity Required')
            this.hasError = true

        }
        if (this.enrollmentViewModel.GENDERNPRONOUN == "4" && (this.enrollmentViewModel.GENDERNPRONOUNOTH == undefined
            || this.enrollmentViewModel.GENDERNPRONOUNOTH == '')) {
            this.ErrorMessages.push('Different Self-Identity is Required')
            this.hasError = true

        }
        */

        if (this.enrollmentViewModel.LANG === undefined || this.enrollmentViewModel.LANG === null) {
            this.ErrorMessages.push('Preferred Language is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.EFFDT === undefined || this.enrollmentViewModel.EFFDT === null) {
            this.ErrorMessages.push('Effective Date is required')
            this.hasError = true
        } else {
            if (this.enrollmentViewModel.EFFDT.getDate() != 1) {
                this.ErrorMessages.push('The Effective Date must fall on the first of the month.')
                this.hasError = true
            }
            if (this.enrollmentViewModel.EFFDT.getFullYear() != this._global.selectedPlanYear) {
                this.ErrorMessages.push('The Effective Date must be in the same year as the Plan Year')
                this.hasError = true
            }
            //if (this.enrollmentViewModel.EFFDT <= this.enrollmentViewModel.APPDT) {
            //    this.ErrorMessages.push('Application date must be prior to the effective date.')
            //    this.hasError = true

            //}
            // var date = new Date()
            //if (this.enrollmentViewModel.EFFDT.getMonth() <= (date.getMonth() - 1) || this.enrollmentViewModel.EFFDT.getMonth() <= (date.getMonth() + 3)) {
            //    this.ErrorMessages.push('The Effective Date can be 1 month before the current month and 3 months after the current month.')
            //    this.hasError = true

            //}
        }

        if (this.enrollmentViewModel.PLANTYPE === undefined || this.enrollmentViewModel.PLANTYPE === '') {
            this.ErrorMessages.push('Plan Type is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.PWO === undefined || this.enrollmentViewModel.PWO === null) {
            this.ErrorMessages.push('Premium Payment is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.OTHCVRG === undefined || this.enrollmentViewModel.OTHCVRG === '') {
            this.ErrorMessages.push('Secondary Coverage is required')
            this.hasError = true
        } else {
            if (this.enrollmentViewModel.OTHCVRG !== undefined && this.enrollmentViewModel.OTHCVRG.toString().toLowerCase() === 'yes') {
                if (this.enrollmentViewModel.OTHCVRGNAME === undefined || this.enrollmentViewModel.OTHCVRGNAME === '') {
                    this.ErrorMessages.push('Other Coverage Name is required')
                    this.hasError = true
                }
                if (
                    this.enrollmentViewModel.OTHCVRGNAME !== undefined &&
                    this.enrollmentViewModel.OTHCVRGNAME !== '' &&
                    this.enrollmentViewModel.OTHCVRGNAME !== null
                ) {
                    let checkONAme = this.enrollmentViewModel.OTHCVRGNAME,
                        regexONameVal = /^[A-Za-z\s\-\' ]+$/
                    let isONAMEValid = regexONameVal.test(checkONAme)
                    if (!isONAMEValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Other Coverage Name is invalid')
                    }
                }
                if (
                    this.enrollmentViewModel.OTHCVRGID !== undefined &&
                    this.enrollmentViewModel.OTHCVRGID !== '' &&
                    this.enrollmentViewModel.OTHCVRGID !== null
                ) {
                    let checkOID = this.enrollmentViewModel.OTHCVRGID,
                        regexOID = new RegExp('^[a-zA-Z0-9 ]*$')
                    let isOIDValid = regexOID.test(checkOID)
                    if (!isOIDValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Other Coverage ID is invalid')
                    }
                }
                if (
                    this.enrollmentViewModel.OTHCVRGGRP !== undefined &&
                    this.enrollmentViewModel.OTHCVRGGRP !== '' &&
                    this.enrollmentViewModel.OTHCVRGGRP !== null
                ) {
                    let checkOTHCVRGGRP = this.enrollmentViewModel.OTHCVRGGRP,
                        regexOTHCVRGGRP = new RegExp('^[a-zA-Z0-9 ]*$')
                    let isOGRPValid = regexOTHCVRGGRP.test(checkOTHCVRGGRP)
                    if (!isOGRPValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Other Coverage Group is invalid')
                    }
                }
                if (
                    this.enrollmentViewModel.COBBIN !== undefined &&
                    this.enrollmentViewModel.COBBIN !== '' &&
                    this.enrollmentViewModel.COBBIN !== null
                ) {
                    let checkCOBBIN = this.enrollmentViewModel.COBBIN,
                        regexCOBBIN = new RegExp('^[a-zA-Z0-9 ]*$')
                    let isCOBBINValid = regexCOBBIN.test(checkCOBBIN)
                    if (!isCOBBINValid) {
                        this.hasError = true
                        this.ErrorMessages.push('OtherCoverageBIN is invalid')
                    }
                }
                if (
                    this.enrollmentViewModel.COBPCN !== undefined &&
                    this.enrollmentViewModel.COBPCN !== '' &&
                    this.enrollmentViewModel.COBPCN !== null
                ) {
                    let checkCOBPCN = this.enrollmentViewModel.COBPCN,
                        regexCOBPCN = new RegExp('^[a-zA-Z0-9 ]*$')
                    let isCOBPCNValid = regexCOBPCN.test(checkCOBPCN)
                    if (!isCOBPCNValid) {
                        this.hasError = true
                        this.ErrorMessages.push('OtherCoveragePcn is invalid')
                    }
                }
            }
        }

        if (this.enrollmentViewModel.PWO === 'Automatic Bank Draft Withdrawal') {
            if (
                this.enrollmentViewModel.ACCHOLDERNAME === undefined ||
                this.enrollmentViewModel.ACCHOLDERNAME === '' ||
                this.enrollmentViewModel.ACCHOLDERNAME === null
            ) {
                this.ErrorMessages.push('Please enter valid Account Name')
                this.hasError = true
            }
            if (
                this.enrollmentViewModel.ACCHOLDERNAME !== undefined &&
                this.enrollmentViewModel.ACCHOLDERNAME !== '' &&
                this.enrollmentViewModel.ACCHOLDERNAME !== null
            ) {
                let checkACCHOLDERNAME = this.enrollmentViewModel.ACCHOLDERNAME,
                    regexACCHOLDERNAMEVal = new RegExp("^[a-zA-Z0-9 -. ']*$")
                let isACCHOLDERNAMEValid = regexACCHOLDERNAMEVal.test(checkACCHOLDERNAME)
                if (!isACCHOLDERNAMEValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Account Name on Bank Account is invalid')
                }
            }
            if (this.enrollmentViewModel.EFTTYPE === undefined || this.enrollmentViewModel.EFTTYPE === '') {
                this.ErrorMessages.push('Please select Account type')
                this.hasError = true
            }
            if (
                this.enrollmentViewModel.FININSTNAME === undefined ||
                this.enrollmentViewModel.FININSTNAME === '' ||
                this.enrollmentViewModel.FININSTNAME === null
            ) {
                this.ErrorMessages.push('Please enter valid Financial Institution')
                this.hasError = true
            }
            if (
                this.enrollmentViewModel.FININSTNAME !== undefined &&
                this.enrollmentViewModel.FININSTNAME !== '' &&
                this.enrollmentViewModel.FININSTNAME !== null
            ) {
                let checkFININSTNAME = this.enrollmentViewModel.FININSTNAME,
                    regexFININSTNAME = new RegExp("^[a-zA-Z0-9 -. ']*$")
                let isFININSTNAMEValid = regexFININSTNAME.test(checkFININSTNAME)
                if (!isFININSTNAMEValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Financial Institution on Bank Account is invalid')
                }
            }
            if (
                this.enrollmentViewModel.ROUTINGNB === undefined ||
                this.enrollmentViewModel.ROUTINGNB === '' ||
                this.enrollmentViewModel.ROUTINGNB == null
            ) {
                this.ErrorMessages.push('Please enter valid Routing Number')
                this.hasError = true
            }
            if (
                this.enrollmentViewModel.ROUTINGNB !== undefined &&
                this.enrollmentViewModel.ROUTINGNB !== '' &&
                this.enrollmentViewModel.ROUTINGNB !== null
            ) {
                let checkROUTINGNB = this.enrollmentViewModel.ROUTINGNB,
                    regexROUTINGNB = new RegExp('^[0-9]*$')
                let isROUTINGNBValid = regexROUTINGNB.test(checkROUTINGNB)
                if (!isROUTINGNBValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Routing Number is invalid')
                }
            }
            if (
                this.enrollmentViewModel.ROUTINGNB !== undefined &&
                this.enrollmentViewModel.ROUTINGNB !== '' &&
                this.enrollmentViewModel.ROUTINGNB !== null
            ) {
                if (this.enrollmentViewModel.ROUTINGNB.length !== 9) {
                    this.hasError = true
                    this.ErrorMessages.push('Routing number must be 9 numbers')
                }
            }

            if (this.enrollmentViewModel.ACCOUNTNB === undefined || this.enrollmentViewModel.ACCOUNTNB === '') {
                this.ErrorMessages.push('Please enter valid Account Number')
                this.hasError = true
            }
            if (
                this.enrollmentViewModel.ACCOUNTNB !== undefined &&
                this.enrollmentViewModel.ACCOUNTNB !== '' &&
                this.enrollmentViewModel.ACCOUNTNB !== null
            ) {
                let checkACCOUNTNB = this.enrollmentViewModel.ACCOUNTNB,
                    regexACCOUNTNB = new RegExp('[0-9]{6}')
                let isACCOUNTNBValid = regexACCOUNTNB.test(checkACCOUNTNB)
                if (!isACCOUNTNBValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Account Number is invalid')
                }
            }
        }

        if (!this.PaperlessOption) {
            if (this.enrollmentViewModel.EOB === undefined || this.enrollmentViewModel.EOB === '') {
                this.ErrorMessages.push('EOB Preference is required')
                this.hasError = true
            } else {
                if (
                    this.enrollmentViewModel.EOB === undefined ||
                    this.enrollmentViewModel.EOB.toString().toLowerCase() === 'eeob' ||
                    this.enrollmentViewModel.EOB.toString().toLowerCase() === '5' ||
                    this.enrollmentViewModel.EOB.toString().toLowerCase() === '6' ||
                    this.enrollmentViewModel.EOB.toString().toLowerCase() === '7' ||
                    this.enrollmentViewModel.EOB.toString().toLowerCase() === '9'
                ) {
                    if (this.enrollmentViewModel.APPEMAIL === undefined || this.enrollmentViewModel.APPEMAIL === ''){
                        this.ErrorMessages.push('Email Address is required for Electronic Explanation of Benefits')
                        this.hasError = true
                    } else {
                        let unicodeRange = '(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])'
                        let checkOrgEmail = this.enrollmentViewModel.APPEMAIL.toLowerCase()

                        let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
                        if (!isOrgEmailValid) {
                            this.hasError = true
                            this.ErrorMessages.push('Invalid Email address for Electronic Explanation of Benefits')
                        }
                    }
                }
                if (this.enrollmentViewModel.EOB === undefined || this.enrollmentViewModel.EOB.toString().toLowerCase() === 'peob') {
                    if (this.enrollmentViewModel.APPEMAIL !== undefined && this.enrollmentViewModel.APPEMAIL !== '') {
                        let unicodeRange = '(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])'
                        let checkOrgEmail = this.enrollmentViewModel.APPEMAIL.toLowerCase()

                        let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
                        if (!isOrgEmailValid) {
                            this.hasError = true
                            this.ErrorMessages.push('Invalid Email address for Electronic Explanation of Benefits')
                        }
                    }
                }
            }
        } else {
            if (
                this.enrollmentViewModel.EOB !== undefined &&
                (this.enrollmentViewModel.EOB.toString().toLowerCase() === 'eeob' ||
                    this.enrollmentViewModel.EOB.toString().toLowerCase() === '5' ||
                    this.enrollmentViewModel.EOB.toString().toLowerCase() === '6' ||
                    this.enrollmentViewModel.EOB.toString().toLowerCase() === '7' ||
                    this.enrollmentViewModel.EOB.toString().toLowerCase() === '9')
            ) {
                if (this.enrollmentViewModel.APPEMAIL === undefined || this.enrollmentViewModel.APPEMAIL === '') {
                    this.ErrorMessages.push('Email Address is required for Paperless Documents')
                    this.hasError = true
                } else {
                    let unicodeRange = '(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])'
                    let checkOrgEmail = this.enrollmentViewModel.APPEMAIL.toLowerCase()

                    let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
                    if (!isOrgEmailValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Invalid Email address for Paperless Documents')
                    }
                }
            }
            if (this.enrollmentViewModel.EOB === undefined || this.enrollmentViewModel.EOB.toString().toLowerCase() === 'n') {
                if (this.enrollmentViewModel.APPEMAIL !== undefined && this.enrollmentViewModel.APPEMAIL !== '') {
                    let unicodeRange = '(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])'
                    let checkOrgEmail = this.enrollmentViewModel.APPEMAIL.toLowerCase()

                    let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
                    if (!isOrgEmailValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Invalid Email address for Paperless Documents')
                    }
                }
            }
        }

        if (this.enrollmentViewModel.APPFN !== undefined && this.enrollmentViewModel.APPFN !== '' && this.enrollmentViewModel.APPFN !== null) {
            let checkFName = this.enrollmentViewModel.APPFN,
                regexFNameVal = new RegExp("^[a-zA-Z.' ]*$")
            let isFnameValid = regexFNameVal.test(checkFName)
            if (!isFnameValid) {
                this.hasError = true
                this.ErrorMessages.push('First Name is invalid')
            }
        }
      
        if (this.enrollmentViewModel.APPLN !== undefined && this.enrollmentViewModel.APPLN !== '' && this.enrollmentViewModel.APPLN !== null) {
            let checkLName = this.enrollmentViewModel.APPLN,
                regexFNameVal = new RegExp("^[a-zA-Z.' -]*$")
            let isLnameValid = regexFNameVal.test(checkLName)
            if (!isLnameValid) {
                this.hasError = true
                this.ErrorMessages.push('Last Name is invalid')
            }
        }
        if (this.enrollmentViewModel.APPMI !== undefined && this.enrollmentViewModel.APPMI !== '' && this.enrollmentViewModel.APPMI !== null) {
            let checkMI = this.enrollmentViewModel.APPMI,
                regexMIVal = new RegExp('^[a-zA-Z ]*$')
            let isMiValid = regexMIVal.test(checkMI)
            if (!isMiValid) {
                this.hasError = true
                this.ErrorMessages.push('MI is invalid')
            }
        }
        if (this.enrollmentViewModel.SUFFIX !== undefined && this.enrollmentViewModel.SUFFIX !== '') {
            let checkSuffix = this.enrollmentViewModel.SUFFIX,
                regexSuffixVal = new RegExp('^[a-zA-Z. 0-9]*$')
            let isSuffixValid = regexSuffixVal.test(checkSuffix)
            if (!isSuffixValid) {
                this.hasError = true
                this.ErrorMessages.push('Suffix is invalid')
            }
        }
        if (this.enrollmentViewModel.APPZIP !== undefined && this.enrollmentViewModel.APPZIP !== '' && this.enrollmentViewModel.APPZIP !== null) {
            let checkZipCode = this.enrollmentViewModel.APPZIP,
                regexVal = new RegExp('[0-9]{5}')
            let isZipCodeValid = regexVal.test(checkZipCode)
            if (!isZipCodeValid) {
                this.hasError = true
                this.ErrorMessages.push('Zip is invalid')
            }
        }
        if (this.enrollmentViewModel.MAILZIP !== undefined && this.enrollmentViewModel.MAILZIP !== '' && this.enrollmentViewModel.MAILZIP !== null) {
            let checkZipCode = this.enrollmentViewModel.MAILZIP,
                regexVal = new RegExp('[0-9]{5}')
            let isZipCodeValid = regexVal.test(checkZipCode)
            if (!isZipCodeValid) {
                this.hasError = true
                this.ErrorMessages.push('Mailing Zip is invalid')
            }
        }

        if (
            this.enrollmentViewModel.APPPHONE !== undefined &&
            this.enrollmentViewModel.APPPHONE !== '' &&
            this.enrollmentViewModel.APPPHONE !== null
        ) {
            let checkOrgPhone = this.enrollmentViewModel.APPPHONE.replace(/-/g, '')
            if (/^\d{10}$/.test(checkOrgPhone)) {
            } else {
                if (!this.isValidNumber(checkOrgPhone)) {
                    this.ErrorMessages.push('Phone cannot contain letters or special characters.')
                    this.hasError = true
                } else {
                    this.ErrorMessages.push('Phone must be exactly 10 numbers.')
                    this.hasError = true
                }
            }
        }
       
        if (
            this.enrollmentViewModel.CELLPHONE !== undefined &&
            this.enrollmentViewModel.CELLPHONE !== '' &&
            this.enrollmentViewModel.CELLPHONE !== null
        ) {
            let checkOrgPhone = this.enrollmentViewModel.CELLPHONE.replace(/-/g, '')
            if (/^\d{10}$/.test(checkOrgPhone)) {
            } else {
                if (!this.isValidNumber(checkOrgPhone)) {
                    this.ErrorMessages.push('CellPhone cannot contain letters or special characters.')
                    this.hasError = true
                } else {
                    this.ErrorMessages.push('CellPhone must be exactly 10 numbers.')
                    this.hasError = true
                }
            }
        }
        if (
            this.enrollmentViewModel.LTCPHONE !== undefined &&
            this.enrollmentViewModel.LTCPHONE !== '' &&
            this.enrollmentViewModel.LTCPHONE !== null
        ) {
            let checkLTCPhone = this.enrollmentViewModel.LTCPHONE.replace(/-/g, '')
            if (/^\d{10}$/.test(checkLTCPhone)) {
            } else {
                if (!this.isValidNumber(checkLTCPhone)) {
                    this.ErrorMessages.push('Long-Term care facility phone cannot contain letters or special characters.')
                    this.hasError = true
                } else {
                    this.ErrorMessages.push('Long-Term care facility Phone must be exactly 10 numbers.')
                    this.hasError = true
                }
            }
        }
        let dob = moment(this.enrollmentViewModel.APPDOB, 'MM/DD/YYYY', true)

        if (dob.isSameOrBefore('1889-12-31')) {
            this.hasError = false
            this.ErrorMessages.push('Invalid Date of Birth.')
        }

        if (this.enrollmentViewModel.PRIORID !== undefined && this.enrollmentViewModel.PRIORID !== '' && this.enrollmentViewModel.PRIORID !== null) {
            if (!this.isAlphaNumericNoSpace(this.enrollmentViewModel.PRIORID)) {
                this.ErrorMessages.push('Invalid Aetna Medicare Id')
                this.hasError = true
            }
        }
              return this.hasError
    }

    private isValidEmail(text: string): boolean {
        return /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,}|[0-9]{1,3})(\]?)$/.test(text)
    }

    goBack(): void {
        this.enrollmentViewModel.ISBACK = true
        this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/data-entry/Step1'])
    }

    residentialAddressChanged(address: AddressDB) {
        this.residentialAddress = this.enrollmentViewModel.residentialAddress = address
        this.enrollmentViewModel.APPADD1 = address.addressLine1
        this.enrollmentViewModel.APPADD2 = address.addressLine2
        this.enrollmentViewModel.APPCITY = address.city
        this.enrollmentViewModel.APPST = address.state
        this.enrollmentViewModel.APPZIP = address.zip
        this.enrollmentViewModel.SAMEADDRESS = address.sameAddress
    }

    mailingAddressChanged(address: AddressDB) {
        this.mailingAddress = this.enrollmentViewModel.mailingAddress = address
        // this.residentialAddress = this.enrollmentViewModel.residentialAddress = address
        this.enrollmentViewModel.MAILADD1 = address.addressLine1
        this.enrollmentViewModel.MAILADD2 = address.addressLine2
        this.enrollmentViewModel.MAILCITY = address.city
        this.enrollmentViewModel.MAILST = address.state
        this.enrollmentViewModel.MAILZIP = address.zip
        this.enrollmentViewModel.SAMEADDRESS = address.sameAddress
    }
    //eobOptionChanged(option: string) {
    //    this.enrollmentViewModel.EOB = option

    //}

    emailChanged(option: string) {
        this.enrollmentViewModel.APPEMAIL = option
    }
    sepdatechange(option: Date) {
        this.enrollmentViewModel.SEPEFFDT = option
    }
    ngOnDestroy() {
        this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
    }

    incompleteClick() {
        // do incomplete validations
        this.ErrorMessages = [] as any[]
        this.hasIncompleteError = false
        if (!this.incompleteClickValidation()) {
            this.enrollmentViewModel.SUBMISSIONTYPECODE = 'INCOMPLETE'
            this.enrollmentViewModel.PLANYEAR = String(this._global.selectedPlanYear)
            this.enrollmentViewModel.Race = this._raceEthnicityComponent.submitRaceDynamic(this.enrollmentViewModel.Race)
            this.enrollmentViewModel.Ethnicity = this._raceEthnicityComponent.submitEthnicityDynamic(this.enrollmentViewModel.Ethnicity)
            this.enrollmentViewModel.EOB = this.SetLanFormat(this.enrollmentViewModel.EOB, this.enrollmentViewModel.accessibility)
            const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
            this.router.navigate(['/' + insCo + '/enrollment/data-entry/Step3'])
        } else {
            this.hasError = true
            this.focusableEleTop.nativeElement.focus()
        }
    }

    private isValidNumber(text: string): boolean {
        return /^\d*$/.test(text)
    }

    incompleteClickValidation(): boolean {
        if (this.enrollmentViewModel.EFFDT === undefined || this.enrollmentViewModel.EFFDT === null) {
            this.ErrorMessages.push('Effective Date is required')
            this.hasIncompleteError = true
        } else {
            if (this.enrollmentViewModel.EFFDT.getFullYear() != this._global.selectedPlanYear) {
                this.ErrorMessages.push('The Effective Date must be in the same year as the Plan Year')
                this.hasIncompleteError = true
            }
        }
        if (this.enrollmentViewModel.ELECTION !== undefined || this.enrollmentViewModel.ELECTION !== '') {
            if (this.enrollmentViewModel.SEPREASONTEXT === undefined || this.enrollmentViewModel.SEPREASONTEXT === '') {
                this.ErrorMessages.push('Enrollment Criteria is required')
                this.hasIncompleteError = true
            }
        }

        //if (this.enrollmentViewModel.APPCITY !== undefined && this.enrollmentViewModel.APPCITY !== '') {
        //    let regexCityVal = /^[A-Za-z\s\-.]+$/
        if (this.enrollmentViewModel.APPCITY !== undefined && this.enrollmentViewModel.APPCITY !== '') {
            let regexCityVal = /^[A-Za-z\s\-.]+$/

            //    let isCityValid = regexCityVal.test(this.enrollmentViewModel.APPCITY)
            //    if (!isCityValid) {
            //        this.hasIncompleteError = true
            //        this.ErrorMessages.push('Please enter valid City')
            //    }
            //}
            let isCityValid = regexCityVal.test(this.enrollmentViewModel.APPCITY)
            if (!isCityValid) {
                this.hasIncompleteError = true
                this.ErrorMessages.push('Please enter valid City')
            }
        }

        if (this.enrollmentViewModel.MAILCITY !== undefined && this.enrollmentViewModel.MAILCITY !== '') {
            let regexCityVal = /^[A-Za-z\s\-.]+$/

            let isCityValid = regexCityVal.test(this.enrollmentViewModel.MAILCITY)
            if (!isCityValid) {
                this.hasIncompleteError = true
                this.ErrorMessages.push('Please enter valid Mailing City')
            }
        }

        if (this.enrollmentViewModel.APPDOB !== undefined && this.enrollmentViewModel.APPDOB !== null) {
            if (this.enrollmentViewModel.APPDOB.toString() !== '') {
                let dob = moment(this.enrollmentViewModel.APPDOB, 'MM/DD/YYYY')

                if (dob.isSameOrBefore('12/31/1889')) {
                    this.hasIncompleteError = true
                    this.ErrorMessages.push('Invalid Date of Birth.')
                } else {
                    if (!isMMDDYYYY(this.enrollmentViewModel.APPDOB.toString())) {
                        this.ErrorMessages.push('Date of Birth does not contain a valid Date')
                        this.hasIncompleteError = true
                    }
                    if (dob > moment()) {
                        this.ErrorMessages.push('Date of Birth cannot be in the future')
                        this.hasIncompleteError = true
                    }
                }
            }
        }

        if (this.enrollmentViewModel.EFFDT !== undefined && this.enrollmentViewModel.EFFDT !== null) {
            if (this.enrollmentViewModel.EFFDT.getDate() != 1) {
                this.ErrorMessages.push('The Effective Date must fall on the first of the month.')
                this.hasIncompleteError = true
            }
            //if (this.enrollmentViewModel.EFFDT <= this.enrollmentViewModel.APPDT) {
            //    this.ErrorMessages.push('Application date must be prior to the effective date.')
            //    this.hasIncompleteError = true

            //}
        }

        if (this.enrollmentViewModel.PWO === 'Automatic Bank Draft Withdrawal') {
            if (
                this.enrollmentViewModel.ACCHOLDERNAME !== undefined &&
                this.enrollmentViewModel.ACCHOLDERNAME !== '' &&
                this.enrollmentViewModel.ACCHOLDERNAME !== null
            ) {
                let checkACCHOLDERNAME = this.enrollmentViewModel.ACCHOLDERNAME,
                    regexACCHOLDERNAMEVal = new RegExp("^[a-zA-Z0-9 -. ']*$")
                let isACCHOLDERNAMEValid = regexACCHOLDERNAMEVal.test(checkACCHOLDERNAME)
                if (!isACCHOLDERNAMEValid) {
                    this.hasIncompleteError = true
                    this.ErrorMessages.push('Account Name on Bank Account is invalid')
                }
            }

            if (
                this.enrollmentViewModel.FININSTNAME !== undefined &&
                this.enrollmentViewModel.FININSTNAME !== '' &&
                this.enrollmentViewModel.FININSTNAME !== null
            ) {
                let checkFININSTNAME = this.enrollmentViewModel.FININSTNAME,
                    regexFININSTNAME = new RegExp("^[a-zA-Z0-9 -. ']*$")
                let isFININSTNAMEValid = regexFININSTNAME.test(checkFININSTNAME)
                if (!isFININSTNAMEValid) {
                    this.hasIncompleteError = true
                    this.ErrorMessages.push('Financial Institution on Bank Account is invalid')
                }
            }

            if (
                this.enrollmentViewModel.ROUTINGNB !== undefined &&
                this.enrollmentViewModel.ROUTINGNB !== '' &&
                this.enrollmentViewModel.ROUTINGNB !== null
            ) {
                let checkRoutingNb = this.enrollmentViewModel.ROUTINGNB,
                    regexVal = new RegExp('[0-9]{9}')
                let isRoutingNbrValid = regexVal.test(checkRoutingNb)
                if (!isRoutingNbrValid) {
                    this.hasIncompleteError = true
                    this.ErrorMessages.push('Routing Number is invalid')
                }
            }
            if (
                this.enrollmentViewModel.ROUTINGNB !== undefined &&
                this.enrollmentViewModel.ROUTINGNB !== '' &&
                this.enrollmentViewModel.ROUTINGNB !== null
            ) {
                if (this.enrollmentViewModel.ROUTINGNB.length !== 9) {
                    this.hasIncompleteError = true
                    this.ErrorMessages.push('Routing number must be 9 numbers')
                }
            }

            if (
                this.enrollmentViewModel.ACCOUNTNB !== undefined &&
                this.enrollmentViewModel.ACCOUNTNB !== '' &&
                this.enrollmentViewModel.ACCOUNTNB !== null
            ) {
                let checkACCOUNTNB = this.enrollmentViewModel.ACCOUNTNB,
                    regexACCOUNTNB = new RegExp('[0-9]{6}')
                let isACCOUNTNBValid = regexACCOUNTNB.test(checkACCOUNTNB)
                if (!isACCOUNTNBValid) {
                    this.hasIncompleteError = true
                    this.ErrorMessages.push('Account Number is invalid')
                }
            }
        }

        if (this.enrollmentViewModel.OTHCVRG !== undefined && this.enrollmentViewModel.OTHCVRG !== '') {
            if (this.enrollmentViewModel.OTHCVRG !== undefined && this.enrollmentViewModel.OTHCVRG.toString().toLowerCase() === 'yes') {
                if (
                    this.enrollmentViewModel.OTHCVRGNAME !== undefined &&
                    this.enrollmentViewModel.OTHCVRGNAME !== '' &&
                    this.enrollmentViewModel.OTHCVRGNAME !== null
                ) {
                    let checkONAme = this.enrollmentViewModel.OTHCVRGNAME,
                        regexONameVal = /^[A-Za-z\s\-\' ]+$/
                    let isONAMEValid = regexONameVal.test(checkONAme)
                    if (!isONAMEValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Other Coverage Name is invalid')
                    }
                }
                if (
                    this.enrollmentViewModel.OTHCVRGID !== undefined &&
                    this.enrollmentViewModel.OTHCVRGID !== '' &&
                    this.enrollmentViewModel.OTHCVRGID !== null
                ) {
                    let checkOID = this.enrollmentViewModel.OTHCVRGID,
                        regexOID = new RegExp('^[a-zA-Z0-9 ]*$')
                    let isOIDValid = regexOID.test(checkOID)
                    if (!isOIDValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Other Coverage ID is invalid')
                    }
                }
                if (
                    this.enrollmentViewModel.OTHCVRGGRP !== undefined &&
                    this.enrollmentViewModel.OTHCVRGGRP !== '' &&
                    this.enrollmentViewModel.OTHCVRGGRP !== null
                ) {
                    let checkOTHCVRGGRP = this.enrollmentViewModel.OTHCVRGGRP,
                        regexOTHCVRGGRP = new RegExp('^[a-zA-Z0-9 ]*$')
                    let isOGRPValid = regexOTHCVRGGRP.test(checkOTHCVRGGRP)
                    if (!isOGRPValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Other Coverage Group is invalid')
                    }
                }
                if (
                    this.enrollmentViewModel.COBBIN !== undefined &&
                    this.enrollmentViewModel.COBBIN !== '' &&
                    this.enrollmentViewModel.COBBIN !== null
                ) {
                    let checkCOBBIN = this.enrollmentViewModel.COBBIN,
                        regexCOBBIN = new RegExp('^[a-zA-Z0-9 ]*$')
                    let isCOBBINValid = regexCOBBIN.test(checkCOBBIN)
                    if (!isCOBBINValid) {
                        this.hasError = true
                        this.ErrorMessages.push('OtherCoverageBIN is invalid')
                    }
                }
                if (
                    this.enrollmentViewModel.COBPCN !== undefined &&
                    this.enrollmentViewModel.COBPCN !== '' &&
                    this.enrollmentViewModel.COBPCN !== null
                ) {
                    let checkCOBPCN = this.enrollmentViewModel.COBPCN,
                        regexCOBPCN = new RegExp('^[a-zA-Z0-9 ]*$')
                    let isCOBPCNValid = regexCOBPCN.test(checkCOBPCN)
                    if (!isCOBPCNValid) {
                        this.hasError = true
                        this.ErrorMessages.push('OtherCoveragePcn is invalid')
                    }
                }
            }
        }

        if (
            this.enrollmentViewModel.EOB !== undefined &&
            (this.enrollmentViewModel.EOB.toString().toLowerCase() === 'eeob' ||
                this.enrollmentViewModel.EOB.toString().toLowerCase() === '5' ||
                this.enrollmentViewModel.EOB.toString().toLowerCase() === '6' ||
                this.enrollmentViewModel.EOB.toString().toLowerCase() === '7')
        ) {
            //if (this.enrollmentViewModel.EOB !== undefined && this.enrollmentViewModel.EOB === '3') {

            if (this.enrollmentViewModel.APPEMAIL !== undefined && this.enrollmentViewModel.APPEMAIL !== '') {
                let unicodeRange = '(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])'
                let checkOrgEmail = this.enrollmentViewModel.APPEMAIL.toLowerCase()

                let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
                if (!isOrgEmailValid) {
                    this.hasIncompleteError = true
                    //this.ErrorMessages.push('Invalid Email address for Electronic Explanation of Benefits')
                    this.ErrorMessages.push('Invalid Email address for Paperless Documents')
                }
            }
        }
        //if (this.enrollmentViewModel.EOB !== undefined && this.enrollmentViewModel.EOB.toString().toLowerCase() === 'peob') {
        if (this.enrollmentViewModel.EOB !== undefined && this.enrollmentViewModel.EOB.toString().toLowerCase() === 'n') {
            if (this.enrollmentViewModel.APPEMAIL !== undefined && this.enrollmentViewModel.APPEMAIL !== '') {
                let unicodeRange = '(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])'
                let checkOrgEmail = this.enrollmentViewModel.APPEMAIL.toLowerCase()

                let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
                if (!isOrgEmailValid) {
                    this.hasIncompleteError = true
                    //this.ErrorMessages.push('Invalid Email address for Electronic Explanation of Benefits')
                    this.ErrorMessages.push('Invalid Email address for Paperless Documents')
                }
                //this.ErrorMessages.push('Email Address is required for Electronic Explanation of Benefits')
                //this.hasError = true
            }
        }

        if (this.enrollmentViewModel.APPFN !== undefined && this.enrollmentViewModel.APPFN !== '' && this.enrollmentViewModel.APPFN !== null) {
            let checkFName = this.enrollmentViewModel.APPFN,
                regexFNameVal = new RegExp("^[a-zA-Z.' ]*$")
            let isFnameValid = regexFNameVal.test(checkFName)
            if (!isFnameValid) {
                this.hasIncompleteError = true
                this.ErrorMessages.push('First Name is invalid')
            }
        }

        if (this.enrollmentViewModel.PRIORID !== undefined && this.enrollmentViewModel.PRIORID !== '' && this.enrollmentViewModel.PRIORID !== null) {
            if (!this.isAlphaNumericNoSpace(this.enrollmentViewModel.PRIORID)) {
                this.ErrorMessages.push('Invalid Aetna Medicare Id')
                this.hasIncompleteError = true
            }
        }

        if (this.enrollmentViewModel.APPLN !== undefined && this.enrollmentViewModel.APPLN !== '' && this.enrollmentViewModel.APPLN !== null) {
            let checkLName = this.enrollmentViewModel.APPLN,
                regexFNameVal = new RegExp("^[a-zA-Z.' -]*$")
            let isLnameValid = regexFNameVal.test(checkLName)
            if (!isLnameValid) {
                this.hasIncompleteError = true
                this.ErrorMessages.push('Last Name is invalid')
            }
        }
        if (this.enrollmentViewModel.APPMI !== undefined && this.enrollmentViewModel.APPMI !== '' && this.enrollmentViewModel.APPMI !== null) {
            let checkMI = this.enrollmentViewModel.APPMI,
                regexMIVal = new RegExp('^[a-zA-Z ]*$')
            let isMiValid = regexMIVal.test(checkMI)
            if (!isMiValid) {
                this.hasIncompleteError = true
                this.ErrorMessages.push('MI is invalid')
            }
        }
        if (this.enrollmentViewModel.SUFFIX !== undefined && this.enrollmentViewModel.SUFFIX !== '') {
            let checkSuffix = this.enrollmentViewModel.SUFFIX,
                regexSuffixVal = new RegExp('^[a-zA-Z. 0-9]*$')
            let isSuffixValid = regexSuffixVal.test(checkSuffix)
            if (!isSuffixValid) {
                this.hasError = true
                this.ErrorMessages.push('Suffix is invalid')
            }
        }
        if (this.enrollmentViewModel.HICN !== undefined && this.enrollmentViewModel.HICN !== '' && this.enrollmentViewModel.HICN !== null) {
            if (this.enrollmentViewModel.HICN.indexOf('-') > -1) {
                this.ErrorMessages.push('Please enter Medicare Number without -')
                this.hasError = true
            } else {
                let checkMedicareNum = this.enrollmentViewModel.HICN,
                    regexMedicareNum = new RegExp(
                        '^([1-9](?![SLOIBZ])[A-Z](?![SLOIBZ])[A-Z 0-9][0-9](?![SLOIBZ])[A-Z](?![SLOIBZ])[A-Z 0-9][0-9](?![SLOIBZ])[A-Z](?![SLOIBZ])[A-Z][0-9][0-9]){1,10}$'
                    )

                checkMedicareNum = checkMedicareNum.replace(/-/g, '')
                if (checkMedicareNum.length == 10) {
                    let medicareNumError = false
                    var bytes = new Uint8Array(checkMedicareNum.length)
                    for (var i = 0; i < checkMedicareNum.length; i++) {
                        var ascii = checkMedicareNum.charCodeAt(i)
                        bytes[i] = ascii
                    }

                    for (var i = 0; i < bytes.length - 1; i++) {
                        if (!(bytes[i] >= 48 && bytes[i] <= 57)) {
                            medicareNumError = true
                        }
                    }
                    var length = bytes.length - 1
                    if (!((bytes[length] >= 65 && bytes[length] <= 90) || (bytes[length] >= 97 && bytes[length] <= 122))) {
                        medicareNumError = true
                    }

                    if (medicareNumError) {
                        this.hasIncompleteError = true
                        this.ErrorMessages.push('Invalid Medicare Number')
                    }
                } else if (checkMedicareNum.length == 11) {
                    let isMediCareNumValid = regexMedicareNum.test(checkMedicareNum)
                    if (!isMediCareNumValid) {
                        this.hasIncompleteError = true
                        this.ErrorMessages.push('Invalid Medicare Number')
                    }
                } else {
                    this.hasIncompleteError = true
                    this.ErrorMessages.push('Invalid Medicare Number')
                }
            }
        }

        if (this.enrollmentViewModel.APPZIP !== undefined && this.enrollmentViewModel.APPZIP !== '' && this.enrollmentViewModel.APPZIP !== null) {
            let checkZipCode = this.enrollmentViewModel.APPZIP,
                regexVal = new RegExp('[0-9]{5}')
            let isZipCodeValid = regexVal.test(checkZipCode)
            if (!isZipCodeValid) {
                this.hasIncompleteError = true
                this.ErrorMessages.push('Zip is invalid')
            }
        }
        if (this.enrollmentViewModel.MAILZIP !== undefined && this.enrollmentViewModel.MAILZIP !== '' && this.enrollmentViewModel.MAILZIP !== null) {
            let checkZipCode = this.enrollmentViewModel.MAILZIP,
                regexVal = new RegExp('[0-9]{5}')
            let isZipCodeValid = regexVal.test(checkZipCode)
            if (!isZipCodeValid) {
                this.hasIncompleteError = true
                this.ErrorMessages.push('Mailing Zip is invalid')
            }
        }

        if (
            this.enrollmentViewModel.APPPHONE !== undefined &&
            this.enrollmentViewModel.APPPHONE !== '' &&
            this.enrollmentViewModel.APPPHONE !== null
        ) {
            let checkOrgPhone = this.enrollmentViewModel.APPPHONE.replace(/-/g, '')
            if (/^\d{10}$/.test(checkOrgPhone)) {
            } else {
                if (!this.isValidNumber(checkOrgPhone)) {
                    this.ErrorMessages.push('Phone cannot contain letters or special characters.')
                    this.hasIncompleteError = true
                } else {
                    this.ErrorMessages.push('Phone must be exactly 10 numbers.')
                    this.hasIncompleteError = true
                }
            }
        }

        if (
            this.enrollmentViewModel.CELLPHONE !== undefined &&
            this.enrollmentViewModel.CELLPHONE !== '' &&
            this.enrollmentViewModel.CELLPHONE !== null
        ) {
            let checkOrgPhone = this.enrollmentViewModel.CELLPHONE.replace(/-/g, '')
            if (/^\d{10}$/.test(checkOrgPhone)) {
            } else {
                if (!this.isValidNumber(checkOrgPhone)) {
                    this.ErrorMessages.push('CellPhone cannot contain letters or special characters.')
                    this.hasIncompleteError = true
                } else {
                    this.ErrorMessages.push('CellPhone must be exactly 10 numbers.')
                    this.hasIncompleteError = true
                }
            }
        }
        if (
            this.enrollmentViewModel.LTCPHONE !== undefined &&
            this.enrollmentViewModel.LTCPHONE !== '' &&
            this.enrollmentViewModel.LTCPHONE !== null
        ) {
            let checkLTCPhone = this.enrollmentViewModel.LTCPHONE.replace(/-/g, '')
            if (/^\d{10}$/.test(checkLTCPhone)) {
            } else {
                if (!this.isValidNumber(checkLTCPhone)) {
                    this.ErrorMessages.push('Long-Term care facility phone cannot contain letters or special characters.')
                    this.hasIncompleteError = true
                } else {
                    this.ErrorMessages.push('Long-Term care facility Phone must be exactly 10 numbers.')
                    this.hasIncompleteError = true
                }
            }
        }
        let dob = moment(this.enrollmentViewModel.APPDOB, 'MM/DD/YYYY', true)

        if (dob.isSameOrBefore('1889-12-31')) {
            this.hasIncompleteError = false
            this.ErrorMessages.push('Invalid Date of Birth.')
        }
        return this.hasIncompleteError
    }

    keyDownFunction(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.formSubmit()
        }
    }

    setAccessibility(lAccessibility) {
        if (this.accessibilityValue != '' && this.accessibilityValue != undefined) {
            lAccessibility = this.accessibilityValue
        }
        if (lAccessibility == '1' || lAccessibility == '5') {
            this.accessibilityValue = '1'
            this.enrollmentViewModel.accessibility = '1'
        }
        if (lAccessibility == '2' || lAccessibility == '6') {
            this.accessibilityValue = '2'
            this.enrollmentViewModel.accessibility = '2'
        }
        if (lAccessibility == '4' || lAccessibility == '7') {
            this.accessibilityValue = '4'
            this.enrollmentViewModel.accessibility = '4'
        }
        if (lAccessibility == '8' || lAccessibility == '9') {
            this.accessibilityValue = '8'
            this.enrollmentViewModel.accessibility = '8'
        }
    }

    SetLanFormat(eob: string, selecteAccessibility: string): string {
        // Set  Access
        this.accessibilityValue = selecteAccessibility

        if (eob == 'EEOB' || eob == 'PEOB') {
            if (this.accessibilityValue != undefined && this.accessibilityValue != '') {
                if (this.accessibilityValue == '1') {
                    if (eob == 'EEOB') {
                        eob = '5'
                    } else {
                        eob = '1'
                    }
                }
                if (this.accessibilityValue == '2') {
                    if (eob == 'EEOB') {
                        eob = '6'
                    } else {
                        eob = '2'
                    }
                }
                if (this.accessibilityValue == '4') {
                    if (eob == 'EEOB') {
                        eob = '7'
                    } else {
                        eob = '4'
                    }
                }
                if (this.accessibilityValue == '8') {
                    if (eob == 'EEOB') {
                        eob = '9'
                    } else {
                        eob = '8'
                    }
                }
            }
        }
        return eob
    }
    private isAlphaNumericNoSpace(text: string): boolean {
        return /^[a-z0-9]+$/i.test(text);
    }
}
